import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import useLoadProfCourse from '../hooks/useLoadProfCourse';
import IntegrityProfCourseGrid from './IntegrityProfCourseGrid';

const ProfCourseGrid = () => {
  const loadProfCourse = useLoadProfCourse();
  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      dataSource={loadProfCourse}
      id={['iD_ProfileSpac', 'iD_Course']}
      allowExport={true}
      integrityGrid={IntegrityProfCourseGrid}
      integrityId={['ID_Course', 'ID_ProfileSpac']}
      integrityName={'ProfCourse'}
      exportName="ProfCourse-export"
      allowActions={false}
    >
      <Column caption={i18n2._('#Curso')} dataField="iD_Course" />
      <Column caption={i18n2._('Curso')} dataField="name_Course" />
      <Column caption={i18n2._('#Perfil Spac')} dataField="iD_ProfileSpac" />
      <Column caption={i18n2._('SPAC')} dataField="spac" />
      <Column
        caption={i18n2._('Nombre del SPAC')}
        dataField="name_Spac"
        defaultSortOrder={'asc'}
      />
      <Column caption={i18n2._('Perfil Spac')} dataField="name_ProfSpac" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default ProfCourseGrid;
